module.exports = __webpack_public_path__ + "static/media/book.80dea87e.svg";